import andrewImg from "@assets/thrive_images/image-thrivers-andrew.png";
import darylImg from "@assets/thrive_images/image-thrivers-daryl.png";
import debbieImg from "@assets/thrive_images/image-thrivers-debbie-small.png";
import lynetteImg from "@assets/thrive_images/image-thrivers-lynette-small.png";
import quekImg from "@assets/thrive_images/image-thrivers-quek-small.jpeg";
import rasunaImg from "@assets/thrive_images/image-thrivers-rasuna-small.png";
import vivienImg from "@assets/thrive_images/image-thrivers-vivien.png";

export const thriversCards = [
  {
    name: "Vivien Shiao",
    image: vivienImg,
    frontText: "Zookeeper",
    backText: [
      {
        topText: "I work hard so I can",
        bottomText: "Be just like Leo In Saint-Tropez",
      },
      {
        topText: "My special skill is",
        bottomText: "Getting things done. Somehow",
      },
      {
        topText: "On the weekends I will be",
        bottomText: "Sleeping till noon",
      },
      {
        topText: "Favourite pantry snack",
        bottomText: "Almond pepero",
      },
      {
        topText: "A movie scene that lives rent-free in my head",
        bottomText:
          "Currently, it's Titanic where Jack dies of hypothermia. Only because the passenger in front of me on the plane watched it 3 times in a row",
      },
    ],
  },
  {
    name: "Daryl Choo",
    image: darylImg,
    frontText: "Grammarly power user",
    backText: [
      {
        topText: "I work hard so I can",
        bottomText: "Buy my dogs nice things",
      },
      {
        topText: "My special skill is",
        bottomText: "Telling apart en dashes and em dashes",
      },
      {
        topText: "On the weekends I will be",
        bottomText: "Playing nanny to my two spoiled cockers",
      },
      {
        topText: "Favourite pantry snack",
        bottomText: "Wang Zai Milk",
      },
      {
        topText: "A movie scene that lives rent-free in my head",
        bottomText: "Opening scene of Eat Drink Man Woman",
      },
    ],
  },
  {
    name: "Andrew Wong",
    image: andrewImg,
    frontText: "Button-presser",
    backText: [
      {
        topText: "I work hard so I can",
        bottomText: "Afford Five Guys",
      },
      {
        topText: "My special skill is",
        bottomText: "Understanding TikTok",
      },
      {
        topText: "On the weekends I will be",
        bottomText: "Cycling or playing Minecraft",
      },
      {
        topText: "Favourite pantry snack",
        bottomText: "None (I prefer my own peanut butter sandwich)",
      },
      {
        topText: "A movie scene that lives rent-free in my head",
        bottomText: "The namecard scene from American Psycho",
      },
    ],
  },
  {
    name: "Lynette Koh",
    image: lynetteImg,
    frontText: "‘ling ling long long' collector",
    backText: [
      {
        topText: "I work hard so I can",
        bottomText: "afford my next concert ticket",
      },
      {
        topText: "My special skill is",
        bottomText: "I heeheehaha my way through anxiety",
      },
      {
        topText: "On the weekends I will be",
        bottomText: "At a sober rave",
      },
      {
        topText: "Favourite pantry snack",
        bottomText: "Crispy M&M's",
      },
      {
        topText: "A movie scene that lives rent-free in my head",
        bottomText:
          'Javier Bardem chanting "Lisan al-Gaib!" for the 124342th time in Dune 2',
      },
    ],
  },
  {
    name: "Rasuna Azrayl",
    image: rasunaImg,
    frontText: "‘fix it in post' guy",
    backText: [
      {
        topText: "I work hard so I can",
        bottomText: "afford YouTube premium",
      },
      {
        topText: "My special skill is",
        bottomText: "Look enthusiastic when i’m not enjoying it",
      },
      {
        topText: "On the weekends I will be",
        bottomText: "Do nothing",
      },
      {
        topText: "Favourite pantry snack",
        bottomText: "Yellow corn snack (i dont know what its called)",
      },
      {
        topText: "A movie scene that lives rent-free in my head",
        bottomText: '"Come cut hair" in Army Daze',
      },
    ],
  },
  {
    name: "Quek Jie Ann",
    image: quekImg,
    frontText: "keyboard tapper",
    backText: [
      {
        topText: "I work hard so I can",
        bottomText: "own a farm one day",
      },
      {
        topText: "My special skill is",
        bottomText: "Psychic readings",
      },
      {
        topText: "On the weekends I will be",
        bottomText: "Cafe hopping",
      },
      {
        topText: "Favourite pantry snack",
        bottomText: "Peanut butter sandwich biscuits",
      },
      {
        topText: "A movie scene that lives rent-free in my head",
        bottomText:
          "When Daniel Kaluuya falls into the Sunken Place in Get Out",
      },
    ],
  },
  {
    name: "Debbie Ng",
    image: debbieImg,
    frontText: "‘make it pop’ IC",
    backText: [
      {
        topText: "I work hard so I can",
        bottomText: "build my cat a mansion",
      },
      {
        topText: "My special skill is",
        bottomText:
          "Starting many short-lived hobbies (I have punch needles and a cricut machine collecting dust)",
      },
      {
        topText: "On the weekends I will be",
        bottomText: "Trying to touch grass",
      },
      {
        topText: "Favourite pantry snack",
        bottomText: "Dewberry biscuit",
      },
      {
        topText: "A movie scene that lives rent-free in my head",
        bottomText: '"Were you rushing or were you dragging?" from Whiplash',
      },
    ],
  },
];
